module.exports = __webpack_public_path__ + "img/鈴木雄登.e32e345a.jpg";